import React from 'react';
import { CardContent } from '@material-ui/core';
import { MediaContainer, ImageWrapper, Image } from './style';
import { ImageCardProps } from './types';
import { Card } from '../Card';

const ImageCard: React.FC<ImageCardProps> = ({ children, imgSrc, imgAlt }) => {
    return (
        <Card>
            {imgSrc && (
                <MediaContainer>
                    <ImageWrapper>
                        <Image src={imgSrc} alt={imgAlt} />
                    </ImageWrapper>
                </MediaContainer>
            )}
            <CardContent>
                {children}
            </CardContent>
        </Card>
    );
};

export default ImageCard;
